import ButtonDropdownMenu from './ButtonDropdownMenu';

const buttonDropdownMenuConfig = {
  name: 'buttonDropdownMenu',
  class: ButtonDropdownMenu,
  querySelector: {
    button: '.button-dropdown-menu__toggle',
  },
  options: {
    dropdownActiveClass: 'button-dropdown-menu--active',
  },
};

export default buttonDropdownMenuConfig;



// WEBPACK FOOTER //
// ./client/js/components/ButtonDropdownMenu/buttonDropdownMenuConfig.js